import React, { Component } from "react";
import { connect } from "react-redux";

class Messaging extends Component {
  render() {
    if (this.props.messages != "" && this.props.messages != null) {
      return (
        <div className="alert alert-danger">
          <strong>Alert!</strong> {this.props.messages}
        </div>
      );
    } else {
      return <div />;
    }
  }
}
export default connect(state => ({
  messages: state.user.messages
}))(Messaging);



// WEBPACK FOOTER //
// ./src/app/views/login/Messaging.js